//! This file is modified by the island-hydration-plugin for esbuild
import { hydrateIslands } from "@renderer/core/client";
import * as pageIslands from "../.././dist/tsup/chip/islands.jsx";
import * as templateIslands from "@framework/templates/default-template/chip/islands";
import * as blocksImports_0 from "@modules/cwc-widget-rendering-blocks/chip/islands";
import * as blocksImports_1 from "@modules/reusable-ui-components/chip/islands";
import { type PageContext } from '@renderer/core';

import '@framework/templates/default-template/chip/style.css';
import '@modules/cwc-widget-rendering-blocks/chip/style.css';

// eslint-disable-next-line @typescript-eslint/no-unused-vars -- module generator
function render(pageContext: PageContext): void {
  hydrateIslands(pageContext.islands, { ...pageIslands, ...templateIslands, ...blocksImports_0,
    ...blocksImports_1 });
  // some hydration code will be injected here by the framework
}
export { render };